{
  "fieldia": "0.13",
  "id": "work-item-bug",
  "title": "Bug",
  "data": { "kind": "record", "model": "work.item" },
  "look": { "theme": "fluent", "skin": "quiet", "density": "compact", "quietHints": false, "lockAt": "value", "readonlyShown": "text" },
  "fields": {
    "number": { "type": "integer", "label": "ID", "readonly": true },
    "work_type": {
      "type": "selection",
      "label": "Work Item Type",
      "options": [{ "value": "bug", "label": "Bug" }, { "value": "task", "label": "Task" }, { "value": "story", "label": "User Story" }]
    },
    "title": { "type": "char", "label": "Title", "required": true },
    "assigned_to": { "type": "many2one", "label": "Assigned To", "relation": "res.users" },
    "comment_count": { "type": "integer", "label": "Comments", "readonly": true },
    "tags": { "type": "many2many", "label": "Tags", "relation": "work.tag" },
    "state": {
      "type": "selection",
      "label": "State",
      "options": [
        { "value": "new", "label": "New" },
        { "value": "active", "label": "Active" },
        { "value": "resolved", "label": "Resolved" },
        { "value": "closed", "label": "Closed" }
      ]
    },
    "reason": {
      "type": "selection",
      "label": "Reason",
      "options": [
        { "value": "new", "label": "New" },
        { "value": "approved", "label": "Approved" },
        { "value": "investigated", "label": "Investigation Complete" },
        { "value": "fixed", "label": "Fixed" },
        { "value": "verified", "label": "Verified" }
      ]
    },
    "area": { "type": "many2one", "label": "Area", "relation": "work.area" },
    "iteration": { "type": "many2one", "label": "Iteration", "relation": "work.iteration" },
    "repro_steps": { "type": "html", "label": "Repro Steps" },
    "system_info": { "type": "html", "label": "System Info" },
    "category": {
      "type": "selection",
      "label": "Category",
      "options": [{ "value": "business", "label": "Business" }, { "value": "architectural", "label": "Architectural" }]
    },
    "resolved_reason": {
      "type": "selection",
      "label": "Resolved Reason",
      "options": [
        { "value": "fixed", "label": "Fixed" },
        { "value": "duplicate", "label": "Duplicate" },
        { "value": "as_designed", "label": "As Designed" },
        { "value": "cannot_reproduce", "label": "Cannot Reproduce" }
      ]
    },
    "story_points": { "type": "float", "label": "Story Points" },
    "priority": {
      "type": "selection",
      "label": "Priority",
      "options": [{ "value": "1", "label": "1" }, { "value": "2", "label": "2" }, { "value": "3", "label": "3" }, { "value": "4", "label": "4" }]
    },
    "severity": {
      "type": "selection",
      "label": "Severity",
      "options": [
        { "value": "1", "label": "1 - Critical" },
        { "value": "2", "label": "2 - High" },
        { "value": "3", "label": "3 - Medium" },
        { "value": "4", "label": "4 - Low" }
      ]
    },
    "activity": {
      "type": "selection",
      "label": "Activity",
      "options": [
        { "value": "deployment", "label": "Deployment" },
        { "value": "design", "label": "Design" },
        { "value": "development", "label": "Development" },
        { "value": "documentation", "label": "Documentation" },
        { "value": "requirements", "label": "Requirements" },
        { "value": "testing", "label": "Testing" }
      ]
    },
    "original_estimate": { "type": "float", "label": "Original Estimate" },
    "remaining_work": { "type": "float", "label": "Remaining" },
    "completed_work": { "type": "float", "label": "Completed" },
    "dev_links": { "type": "many2many", "label": "Development", "relation": "dev.link" },
    "related": { "type": "many2many", "label": "Related Work", "relation": "work.item" },
    "found_in": { "type": "char", "label": "Found in Build" },
    "integrated_in": { "type": "char", "label": "Integrated in Build" },
    "changed_by": { "type": "many2one", "label": "Changed By", "relation": "res.users", "readonly": true },
    "changed_date": { "type": "datetime", "label": "Changed Date", "readonly": true },
    "following": { "type": "boolean", "label": "Following", "readonly": true },
    "attachments": { "type": "binary", "label": "Attachments", "multiple": true }
  },
  "layout": {
    "type": "sheet",
    "id": "bug",
    "head": {
      "kind": {
        "field": "work_type",
        "numberField": "number",
        "looks": { "bug": { "colour": "#cc293d", "icon": "bug" }, "task": { "colour": "#f2cb1d", "icon": "task" }, "story": { "colour": "#009ccc", "icon": "story" } }
      },
      "meta": [
        {
          "type": "field",
          "id": "h-assigned",
          "field": "assigned_to",
          "labels": "hidden",
          "placeholder": "No one selected",
          "options": { "avatar": true }
        },
        {
          "type": "link",
          "id": "h-comments",
          "icon": "chat",
          "field": "comment_count",
          "words": { "one": "Comment", "other": "Comments" },
          "target": "g-discussion"
        },
        {
          "type": "field",
          "id": "h-tags",
          "field": "tags",
          "widget": "tags",
          "labels": "hidden",
          "placeholder": "Add Tag",
          "options": { "adder": "button" }
        }
      ],
      "actions": [
        {
          "type": "button",
          "id": "b-save-close",
          "label": "Save and Close",
          "icon": "save",
          "primaryWhenChanged": true,
          "steps": [{ "do": "save" }, { "do": "close" }],
          "menu": [{ "id": "m-save", "label": "Save", "steps": [{ "do": "save" }] }]
        },
        {
          "type": "button",
          "id": "b-follow",
          "label": "Follow",
          "pressedLabel": "Following",
          "icon": "eye",
          "pressed": "following",
          "action": "follow",
          "menuIcon": "gear",
          "menuLabel": "Notification settings",
          "menu": [
            { "id": "m-follow-all", "label": "All changes", "action": "follow-all" },
            { "id": "m-follow-state", "label": "State changes", "action": "follow-state" }
          ]
        },
        { "type": "button", "id": "b-refresh", "label": "Refresh", "icon": "refresh", "iconOnly": true, "steps": [{ "do": "reload" }] },
        { "type": "button", "id": "b-undo", "label": "Revert changes", "icon": "undo", "iconOnly": true, "steps": [{ "do": "reset" }] }
      ],
      "band": {
        "tracks": ["274px", "1fr"],
        "labelWidth": 76,
        "children": [
          {
            "type": "field",
            "id": "f-state",
            "field": "state",
            "widget": "dot",
            "hotkey": "e",
            "options": { "label": true, "listDots": false, "colours": { "new": "#b2b2b2", "active": "#007acc", "resolved": "#ff9d00", "closed": "#339933" } }
          },
          { "type": "field", "id": "f-area", "field": "area", "widget": "path", "hotkey": "a" },
          { "type": "field", "id": "f-reason", "field": "reason", "readonly": true, "readonlyReason": "Set by the workflow when the State changes" },
          { "type": "field", "id": "f-iteration", "field": "iteration", "widget": "path", "hotkey": "r" }
        ]
      },
      "updated": { "byField": "changed_by", "atField": "changed_date", "opens": "t-history" }
    },
    "title": { "field": "title", "before": [{ "type": "field", "id": "t-number", "field": "number", "labels": "hidden" }] },
    "toolbar": {
      "menu": [
        { "id": "m-new-linked", "label": "New linked work item", "icon": "plus", "action": "new-linked" },
        { "id": "m-change-type", "label": "Change type…", "icon": "swap", "action": "change-type" },
        { "id": "m-move", "label": "Move to team project…", "icon": "move", "action": "move-project" },
        { "id": "m-copy", "label": "Create copy of work item…", "icon": "copy", "builtin": "duplicate" },
        { "id": "m-email", "label": "Email work item", "icon": "mail", "action": "email" },
        { "id": "m-delete", "label": "Delete", "icon": "trash", "builtin": "delete" },
        { "id": "m-copy-link", "label": "Copy link", "icon": "link", "action": "copy-link" },
        { "id": "m-rule-1", "type": "divider" },
        {
          "id": "m-templates",
          "label": "Templates",
          "icon": "template",
          "menuFrom": "templates",
          "menu": [
            { "id": "m-capture", "label": "Capture…", "action": "capture-template" },
            { "id": "m-rule-templates", "type": "divider" }
          ]
        },
        { "id": "m-rule-2", "type": "divider" },
        { "id": "m-branch", "label": "New branch…", "icon": "branch", "action": "new-branch" },
        { "id": "m-rule-3", "type": "divider" },
        { "id": "m-customize", "label": "Customize", "icon": "brush", "action": "customize" }
      ]
    },
    "children": [
      {
        "type": "tabs",
        "id": "wi-tabs",
        "place": "head",
        "children": [
          {
            "type": "tab",
            "id": "t-details",
            "label": "Details",
            "children": [
              {
                "type": "section",
                "id": "cols",
                "style": "plain",
                "columns": 3,
                "tracks": ["50%", "1fr", "1fr"],
                "gap": 16,
                "children": [
                  {
                    "type": "section",
                    "id": "col-1",
                    "style": "plain",
                    "children": [
                      {
                        "type": "section",
                        "id": "g-repro",
                        "title": "Repro Steps",
                        "style": "line",
                        "collapsible": true,
                        "foldAt": "end",
                        "maximise": true,
                        "children": [
                          {
                            "type": "field",
                            "id": "f-repro",
                            "field": "repro_steps",
                            "labels": "hidden",
                            "options": {
                              "editor": "markdown",
                              "toolbar": "focus",
                              "tools": [
                                "mention",
                                "reference",
                                "attach",
                                "highlight",
                                "heading",
                                "bold",
                                "italic",
                                "code",
                                "link",
                                "bulletList",
                                "numberList",
                                "taskList"
                              ],
                              "mention": { "model": "res.users" },
                              "references": [
                                { "key": "#", "model": "work.item", "label": "Work item", "icon": "hash" },
                                { "key": "!", "model": "pull.request", "label": "Pull request", "icon": "pull-request" }
                              ]
                            }
                          }
                        ]
                      },
                      {
                        "type": "section",
                        "id": "g-system",
                        "title": "System Info",
                        "style": "line",
                        "collapsible": true,
                        "foldAt": "end",
                        "maximise": true,
                        "children": [
                          {
                            "type": "field",
                            "id": "f-system",
                            "field": "system_info",
                            "labels": "hidden",
                            "placeholder": "Click to add System Info.",
                            "options": {
                              "editor": "rich",
                              "edit": "button",
                              "toolbar": "focus",
                              "toolbarAt": "bottom",
                              "switchEditor": true,
                              "tools": [
                                "bold",
                                "italic",
                                "underline",
                                "bulletList",
                                "numberList",
                                "highlight",
                                "colour",
                                "emoji",
                                "outdent",
                                "indent",
                                "strike",
                                "size",
                                "code",
                                "mention",
                                "reference",
                                "clearFormatting",
                                "image",
                                "link",
                                "unlink"
                              ],
                              "mention": { "model": "res.users" },
                              "references": [
                                { "key": "#", "model": "work.item", "label": "Work item", "icon": "hash" },
                                { "key": "!", "model": "pull.request", "label": "Pull request", "icon": "pull-request" }
                              ]
                            }
                          }
                        ]
                      },
                      {
                        "type": "section",
                        "id": "g-discussion",
                        "title": "Discussion",
                        "style": "line",
                        "collapsible": true,
                        "foldAt": "end",
                        "maximise": true,
                        "children": [{ "type": "slot", "id": "s-discussion", "name": "discussion" }]
                      }
                    ]
                  },
                  {
                    "type": "section",
                    "id": "col-2",
                    "style": "plain",
                    "children": [
                      {
                        "type": "section",
                        "id": "g-planning",
                        "title": "Planning",
                        "style": "line",
                        "collapsible": true,
                        "foldAt": "end",
                        "children": [
                          { "type": "field", "id": "f-category", "field": "category", "options": { "list": "own" } },
                          {
                            "type": "field",
                            "id": "f-resolved-reason",
                            "field": "resolved_reason",
                            "readonly": true,
                            "readonlyReason": "Set when the bug is resolved"
                          },
                          { "type": "field", "id": "f-points", "field": "story_points" },
                          { "type": "field", "id": "f-priority", "field": "priority", "options": { "list": "own" } },
                          { "type": "field", "id": "f-severity", "field": "severity", "options": { "list": "own" } },
                          { "type": "field", "id": "f-activity", "field": "activity", "options": { "list": "own" } }
                        ]
                      },
                      {
                        "type": "section",
                        "id": "g-effort",
                        "title": "Effort (Hours)",
                        "style": "line",
                        "collapsible": true,
                        "foldAt": "end",
                        "children": [
                          { "type": "field", "id": "f-estimate", "field": "original_estimate" },
                          { "type": "field", "id": "f-remaining", "field": "remaining_work" },
                          { "type": "field", "id": "f-completed", "field": "completed_work" }
                        ]
                      }
                    ]
                  },
                  {
                    "type": "section",
                    "id": "col-3",
                    "style": "plain",
                    "children": [
                      {
                        "type": "section",
                        "id": "g-deployment",
                        "title": "Deployment",
                        "style": "line",
                        "collapsible": true,
                        "foldAt": "end",
                        "children": [
                          {
                            "type": "text",
                            "id": "x-deployment",
                            "style": "help",
                            "text": "To track releases associated with this work item, go to [Releases](https://example.com/releases) and turn on deployment status reporting for Boards in your pipeline's Options menu. [Learn more about deployment status reporting](https://example.com/help/deployment-status)"
                          }
                        ]
                      },
                      {
                        "type": "section",
                        "id": "g-development",
                        "title": "Development",
                        "style": "line",
                        "collapsible": true,
                        "foldAt": "end",
                        "children": [
                          {
                            "type": "field",
                            "id": "f-dev",
                            "field": "dev_links",
                            "widget": "links",
                            "labels": "hidden",
                            "options": {
                              "add": "search",
                              "helpIcon": "branch",
                              "helpTile": "#d84a12",
                              "help": "Link a [commit](https://example.com/help/commit), [pull request](https://example.com/help/pull-request) or [branch](https://example.com/help/branch) to see the status of your development. You can also [create a branch](https://example.com/help/new-branch) to get started."
                            }
                          }
                        ]
                      },
                      {
                        "type": "section",
                        "id": "g-related",
                        "title": "Related Work",
                        "style": "line",
                        "collapsible": true,
                        "foldAt": "end",
                        "children": [
                          {
                            "type": "field",
                            "id": "f-related",
                            "field": "related",
                            "widget": "links",
                            "labels": "hidden",
                            "options": { "add": "menu", "emptyLink": "Add an existing work item as a parent" }
                          }
                        ]
                      },
                      {
                        "type": "section",
                        "id": "g-build",
                        "title": "System Info",
                        "style": "line",
                        "collapsible": true,
                        "foldAt": "end",
                        "children": [{ "type": "field", "id": "f-found", "field": "found_in" }, { "type": "field", "id": "f-integrated", "field": "integrated_in" }]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "type": "tab",
            "id": "t-history",
            "label": "History",
            "icon": "history",
            "iconOnly": true,
            "children": [{ "type": "slot", "id": "s-history", "name": "history" }]
          },
          {
            "type": "tab",
            "id": "t-links",
            "label": "Links",
            "icon": "link",
            "iconOnly": true,
            "count": "related",
            "children": [{ "type": "field", "id": "f-links-all", "field": "related", "widget": "links", "labels": "hidden", "options": { "add": "menu" } }]
          },
          {
            "type": "tab",
            "id": "t-attachments",
            "label": "Attachments",
            "icon": "attach",
            "iconOnly": true,
            "count": "attachments",
            "children": [{ "type": "field", "id": "f-files", "field": "attachments", "labels": "hidden" }]
          }
        ]
      }
    ]
  },
  "translations": {
    "ar": {
      "Bug": "خلل",
      "ID": "المعرّف",
      "Work Item Type": "نوع بند العمل",
      "Task": "مهمة",
      "User Story": "قصة مستخدم",
      "Title": "العنوان",
      "Assigned To": "مُسنَد إلى",
      "Comments": "تعليقات",
      "Comment": "تعليق",
      "Tags": "الوسوم",
      "State": "الحالة",
      "New": "جديد",
      "Active": "نشط",
      "Resolved": "محلول",
      "Closed": "مغلق",
      "Reason": "السبب",
      "Approved": "معتمد",
      "Investigation Complete": "اكتمل التحقيق",
      "Fixed": "تم الإصلاح",
      "Verified": "تم التحقق",
      "Area": "المجال",
      "Iteration": "التكرار",
      "Repro Steps": "خطوات إعادة الإنتاج",
      "System Info": "معلومات النظام",
      "Category": "الفئة",
      "Business": "الأعمال",
      "Architectural": "معماري",
      "Resolved Reason": "سبب الحل",
      "Duplicate": "مكرر",
      "As Designed": "كما صُمّم",
      "Cannot Reproduce": "تتعذّر إعادة الإنتاج",
      "Story Points": "نقاط القصة",
      "Priority": "الأولوية",
      "Severity": "الخطورة",
      "1 - Critical": "1 - حرجة",
      "2 - High": "2 - عالية",
      "3 - Medium": "3 - متوسطة",
      "4 - Low": "4 - منخفضة",
      "Activity": "النشاط",
      "Deployment": "النشر",
      "Design": "التصميم",
      "Development": "التطوير",
      "Documentation": "التوثيق",
      "Requirements": "المتطلبات",
      "Testing": "الاختبار",
      "Original Estimate": "التقدير الأصلي",
      "Remaining": "المتبقي",
      "Completed": "المنجز",
      "Related Work": "العمل المرتبط",
      "Found in Build": "وُجد في الإصدار",
      "Integrated in Build": "دُمج في الإصدار",
      "Changed By": "غيّره",
      "Changed Date": "تاريخ التغيير",
      "Following": "تتم المتابعة",
      "Attachments": "المرفقات",
      "No one selected": "لم يُحدَّد أحد",
      "Add Tag": "إضافة وسم",
      "Save and Close": "حفظ وإغلاق",
      "Save": "حفظ",
      "Follow": "متابعة",
      "Notification settings": "إعدادات الإشعارات",
      "All changes": "كل التغييرات",
      "State changes": "تغييرات الحالة",
      "Refresh": "تحديث",
      "Revert changes": "التراجع عن التغييرات",
      "Set by the workflow when the State changes": "يضبطه سير العمل عند تغيّر الحالة",
      "Set when the bug is resolved": "يُضبط عند حل الخلل",
      "Copy link": "نسخ الرابط",
      "New linked work item": "بند عمل مرتبط جديد",
      "Change type…": "تغيير النوع…",
      "Move to team project…": "نقل إلى مشروع فريق…",
      "Create copy of work item…": "إنشاء نسخة من بند العمل…",
      "Email work item": "إرسال بند العمل بالبريد",
      "Delete": "حذف",
      "Templates": "القوالب",
      "Capture…": "حفظ كقالب…",
      "New branch…": "فرع جديد…",
      "Customize": "تخصيص",
      "Details": "التفاصيل",
      "History": "السجل",
      "Links": "الروابط",
      "Discussion": "النقاش",
      "Planning": "التخطيط",
      "Effort (Hours)": "الجهد (بالساعات)",
      "Click to add System Info.": "انقر لإضافة معلومات النظام.",
      "Add an existing work item as a parent": "إضافة بند عمل موجود كأصل",
      "To track releases associated with this work item, go to [Releases](https://example.com/releases) and turn on deployment status reporting for Boards in your pipeline's Options menu. [Learn more about deployment status reporting](https://example.com/help/deployment-status)": "لتتبّع الإصدارات المرتبطة بعنصر العمل هذا، انتقل إلى [الإصدارات](https://example.com/releases) وشغّل الإبلاغ عن حالة النشر للوحات في قائمة خيارات مسارك. [اعرف المزيد عن الإبلاغ عن حالة النشر](https://example.com/help/deployment-status)",
      "Link a [commit](https://example.com/help/commit), [pull request](https://example.com/help/pull-request) or [branch](https://example.com/help/branch) to see the status of your development. You can also [create a branch](https://example.com/help/new-branch) to get started.": "اربط [إيداعًا](https://example.com/help/commit) أو [طلب سحب](https://example.com/help/pull-request) أو [فرعًا](https://example.com/help/branch) لترى حالة التطوير. يمكنك أيضًا [إنشاء فرع](https://example.com/help/new-branch) للبدء.",
      "Work item": "بند عمل",
      "Pull request": "طلب سحب"
    },
    "de": {
      "Bug": "Fehler",
      "ID": "ID",
      "Work Item Type": "Arbeitselementtyp",
      "Task": "Aufgabe",
      "User Story": "User Story",
      "Title": "Titel",
      "Assigned To": "Zugewiesen an",
      "Comments": "Kommentare",
      "Comment": "Kommentar",
      "Tags": "Tags",
      "State": "Status",
      "New": "Neu",
      "Active": "Aktiv",
      "Resolved": "Gelöst",
      "Closed": "Geschlossen",
      "Reason": "Grund",
      "Approved": "Genehmigt",
      "Investigation Complete": "Untersuchung abgeschlossen",
      "Fixed": "Behoben",
      "Verified": "Überprüft",
      "Area": "Bereich",
      "Iteration": "Iteration",
      "Repro Steps": "Schritte zum Reproduzieren",
      "System Info": "Systeminfo",
      "Category": "Kategorie",
      "Business": "Geschäft",
      "Architectural": "Architektur",
      "Resolved Reason": "Lösungsgrund",
      "Duplicate": "Duplikat",
      "As Designed": "Wie entworfen",
      "Cannot Reproduce": "Nicht reproduzierbar",
      "Story Points": "Story Points",
      "Priority": "Priorität",
      "Severity": "Schweregrad",
      "1 - Critical": "1 - Kritisch",
      "2 - High": "2 - Hoch",
      "3 - Medium": "3 - Mittel",
      "4 - Low": "4 - Niedrig",
      "Activity": "Aktivität",
      "Deployment": "Bereitstellung",
      "Design": "Entwurf",
      "Development": "Entwicklung",
      "Documentation": "Dokumentation",
      "Requirements": "Anforderungen",
      "Testing": "Testen",
      "Original Estimate": "Ursprüngliche Schätzung",
      "Remaining": "Verbleibend",
      "Completed": "Abgeschlossen",
      "Related Work": "Verwandte Arbeit",
      "Found in Build": "Gefunden in Build",
      "Integrated in Build": "Integriert in Build",
      "Changed By": "Geändert von",
      "Changed Date": "Änderungsdatum",
      "Following": "Folge ich",
      "Attachments": "Anlagen",
      "No one selected": "Niemand ausgewählt",
      "Add Tag": "Tag hinzufügen",
      "Save and Close": "Speichern und schließen",
      "Save": "Speichern",
      "Follow": "Folgen",
      "Notification settings": "Benachrichtigungseinstellungen",
      "All changes": "Alle Änderungen",
      "State changes": "Statusänderungen",
      "Refresh": "Aktualisieren",
      "Revert changes": "Änderungen zurücksetzen",
      "Set by the workflow when the State changes": "Wird vom Workflow gesetzt, wenn sich der Status ändert",
      "Set when the bug is resolved": "Wird gesetzt, wenn der Fehler gelöst ist",
      "Copy link": "Link kopieren",
      "New linked work item": "Neues verknüpftes Arbeitselement",
      "Change type…": "Typ ändern…",
      "Move to team project…": "In Teamprojekt verschieben…",
      "Create copy of work item…": "Kopie des Arbeitselements erstellen…",
      "Email work item": "Arbeitselement per E-Mail senden",
      "Delete": "Löschen",
      "Templates": "Vorlagen",
      "Capture…": "Erfassen…",
      "New branch…": "Neuer Branch…",
      "Customize": "Anpassen",
      "Details": "Details",
      "History": "Verlauf",
      "Links": "Links",
      "Discussion": "Diskussion",
      "Planning": "Planung",
      "Effort (Hours)": "Aufwand (Stunden)",
      "Click to add System Info.": "Klicken, um Systeminfo hinzuzufügen.",
      "Add an existing work item as a parent": "Vorhandenes Arbeitselement als übergeordnetes Element hinzufügen",
      "To track releases associated with this work item, go to [Releases](https://example.com/releases) and turn on deployment status reporting for Boards in your pipeline's Options menu. [Learn more about deployment status reporting](https://example.com/help/deployment-status)": "Um Releases zu diesem Arbeitselement zu verfolgen, öffnen Sie [Releases](https://example.com/releases) und schalten Sie im Optionsmenü Ihrer Pipeline die Meldung des Bereitstellungsstatus für Boards ein. [Mehr über die Meldung des Bereitstellungsstatus](https://example.com/help/deployment-status)",
      "Link a [commit](https://example.com/help/commit), [pull request](https://example.com/help/pull-request) or [branch](https://example.com/help/branch) to see the status of your development. You can also [create a branch](https://example.com/help/new-branch) to get started.": "Verknüpfen Sie einen [Commit](https://example.com/help/commit), einen [Pull Request](https://example.com/help/pull-request) oder einen [Branch](https://example.com/help/branch), um den Stand Ihrer Entwicklung zu sehen. Sie können auch [einen Branch erstellen](https://example.com/help/new-branch), um zu beginnen.",
      "Work item": "Arbeitselement",
      "Pull request": "Pull Request"
    },
    "fr": {
      "Bug": "Bogue",
      "ID": "ID",
      "Work Item Type": "Type d’élément de travail",
      "Task": "Tâche",
      "User Story": "Récit utilisateur",
      "Title": "Titre",
      "Assigned To": "Attribué à",
      "Comments": "Commentaires",
      "Comment": "Commentaire",
      "Tags": "Balises",
      "State": "État",
      "New": "Nouveau",
      "Active": "Actif",
      "Resolved": "Résolu",
      "Closed": "Fermé",
      "Reason": "Raison",
      "Approved": "Approuvé",
      "Investigation Complete": "Analyse terminée",
      "Fixed": "Corrigé",
      "Verified": "Vérifié",
      "Area": "Zone",
      "Iteration": "Itération",
      "Repro Steps": "Étapes de reproduction",
      "System Info": "Infos système",
      "Category": "Catégorie",
      "Business": "Métier",
      "Architectural": "Architecture",
      "Resolved Reason": "Raison de la résolution",
      "Duplicate": "Doublon",
      "As Designed": "Conforme à la conception",
      "Cannot Reproduce": "Non reproductible",
      "Story Points": "Points de récit",
      "Priority": "Priorité",
      "Severity": "Gravité",
      "1 - Critical": "1 - Critique",
      "2 - High": "2 - Élevée",
      "3 - Medium": "3 - Moyenne",
      "4 - Low": "4 - Faible",
      "Activity": "Activité",
      "Deployment": "Déploiement",
      "Design": "Conception",
      "Development": "Développement",
      "Documentation": "Documentation",
      "Requirements": "Exigences",
      "Testing": "Tests",
      "Original Estimate": "Estimation initiale",
      "Remaining": "Restant",
      "Completed": "Terminé",
      "Related Work": "Travail associé",
      "Found in Build": "Trouvé dans la build",
      "Integrated in Build": "Intégré dans la build",
      "Changed By": "Modifié par",
      "Changed Date": "Date de modification",
      "Following": "Suivi",
      "Attachments": "Pièces jointes",
      "No one selected": "Personne n’est sélectionné",
      "Add Tag": "Ajouter une balise",
      "Save and Close": "Enregistrer et fermer",
      "Save": "Enregistrer",
      "Follow": "Suivre",
      "Notification settings": "Paramètres de notification",
      "All changes": "Toutes les modifications",
      "State changes": "Changements d’état",
      "Refresh": "Actualiser",
      "Revert changes": "Annuler les modifications",
      "Set by the workflow when the State changes": "Défini par le flux de travail quand l’état change",
      "Set when the bug is resolved": "Défini quand le bogue est résolu",
      "Copy link": "Copier le lien",
      "New linked work item": "Nouvel élément de travail lié",
      "Change type…": "Changer le type…",
      "Move to team project…": "Déplacer vers un projet d’équipe…",
      "Create copy of work item…": "Créer une copie de l’élément de travail…",
      "Email work item": "Envoyer l’élément de travail par e-mail",
      "Delete": "Supprimer",
      "Templates": "Modèles",
      "Capture…": "Capturer…",
      "New branch…": "Nouvelle branche…",
      "Customize": "Personnaliser",
      "Details": "Détails",
      "History": "Historique",
      "Links": "Liens",
      "Discussion": "Discussion",
      "Planning": "Planification",
      "Effort (Hours)": "Effort (heures)",
      "Click to add System Info.": "Cliquez pour ajouter les infos système.",
      "Add an existing work item as a parent": "Ajouter un élément de travail existant comme parent",
      "To track releases associated with this work item, go to [Releases](https://example.com/releases) and turn on deployment status reporting for Boards in your pipeline's Options menu. [Learn more about deployment status reporting](https://example.com/help/deployment-status)": "Pour suivre les versions liées à cet élément de travail, allez dans [Versions](https://example.com/releases) et activez le suivi de l’état du déploiement pour les tableaux dans le menu Options de votre pipeline. [En savoir plus sur le suivi de l’état du déploiement](https://example.com/help/deployment-status)",
      "Link a [commit](https://example.com/help/commit), [pull request](https://example.com/help/pull-request) or [branch](https://example.com/help/branch) to see the status of your development. You can also [create a branch](https://example.com/help/new-branch) to get started.": "Liez un [commit](https://example.com/help/commit), une [demande de tirage](https://example.com/help/pull-request) ou une [branche](https://example.com/help/branch) pour voir où en est le développement. Vous pouvez aussi [créer une branche](https://example.com/help/new-branch) pour commencer.",
      "Work item": "un élément de travail",
      "Pull request": "une demande de tirage"
    },
    "tr": {
      "Bug": "Hata",
      "ID": "Kimlik",
      "Work Item Type": "İş öğesi türü",
      "Task": "Görev",
      "User Story": "Kullanıcı hikayesi",
      "Title": "Başlık",
      "Assigned To": "Atanan",
      "Comments": "Yorum",
      "Comment": "Yorum",
      "Tags": "Etiketler",
      "State": "Durum",
      "New": "Yeni",
      "Active": "Etkin",
      "Resolved": "Çözümlendi",
      "Closed": "Kapalı",
      "Reason": "Neden",
      "Approved": "Onaylandı",
      "Investigation Complete": "İnceleme tamamlandı",
      "Fixed": "Düzeltildi",
      "Verified": "Doğrulandı",
      "Area": "Alan",
      "Iteration": "Yineleme",
      "Repro Steps": "Yeniden oluşturma adımları",
      "System Info": "Sistem bilgileri",
      "Category": "Kategori",
      "Business": "İş",
      "Architectural": "Mimari",
      "Resolved Reason": "Çözümleme nedeni",
      "Duplicate": "Yinelenen",
      "As Designed": "Tasarlandığı gibi",
      "Cannot Reproduce": "Yeniden oluşturulamıyor",
      "Story Points": "Hikaye puanları",
      "Priority": "Öncelik",
      "Severity": "Önem derecesi",
      "1 - Critical": "1 - Kritik",
      "2 - High": "2 - Yüksek",
      "3 - Medium": "3 - Orta",
      "4 - Low": "4 - Düşük",
      "Activity": "Etkinlik",
      "Deployment": "Dağıtım",
      "Design": "Tasarım",
      "Development": "Geliştirme",
      "Documentation": "Belgelendirme",
      "Requirements": "Gereksinimler",
      "Testing": "Test",
      "Original Estimate": "İlk tahmin",
      "Remaining": "Kalan",
      "Completed": "Tamamlanan",
      "Related Work": "İlgili iş",
      "Found in Build": "Bulunduğu derleme",
      "Integrated in Build": "Tümleştirildiği derleme",
      "Changed By": "Değiştiren",
      "Changed Date": "Değiştirilme tarihi",
      "Following": "Takip ediliyor",
      "Attachments": "Ekler",
      "No one selected": "Kimse seçilmedi",
      "Add Tag": "Etiket ekle",
      "Save and Close": "Kaydet ve kapat",
      "Save": "Kaydet",
      "Follow": "Takip et",
      "Notification settings": "Bildirim ayarları",
      "All changes": "Tüm değişiklikler",
      "State changes": "Durum değişiklikleri",
      "Refresh": "Yenile",
      "Revert changes": "Değişiklikleri geri al",
      "Set by the workflow when the State changes": "Durum değiştiğinde iş akışı tarafından ayarlanır",
      "Set when the bug is resolved": "Hata çözümlendiğinde ayarlanır",
      "Copy link": "Bağlantıyı kopyala",
      "New linked work item": "Yeni bağlantılı iş öğesi",
      "Change type…": "Türü değiştir…",
      "Move to team project…": "Ekip projesine taşı…",
      "Create copy of work item…": "İş öğesinin kopyasını oluştur…",
      "Email work item": "İş öğesini e-postayla gönder",
      "Delete": "Sil",
      "Templates": "Şablonlar",
      "Capture…": "Yakala…",
      "New branch…": "Yeni dal…",
      "Customize": "Özelleştir",
      "Details": "Ayrıntılar",
      "History": "Geçmiş",
      "Links": "Bağlantılar",
      "Discussion": "Tartışma",
      "Planning": "Planlama",
      "Effort (Hours)": "Efor (saat)",
      "Click to add System Info.": "Sistem bilgisi eklemek için tıklayın.",
      "Add an existing work item as a parent": "Mevcut bir iş öğesini üst öğe olarak ekle",
      "To track releases associated with this work item, go to [Releases](https://example.com/releases) and turn on deployment status reporting for Boards in your pipeline's Options menu. [Learn more about deployment status reporting](https://example.com/help/deployment-status)": "Bu iş öğesiyle ilişkili yayınları izlemek için [Yayınlar](https://example.com/releases) bölümüne gidin ve işlem hattınızın Seçenekler menüsünde Panolar için dağıtım durumu raporlamasını açın. [Dağıtım durumu raporlaması hakkında daha fazla bilgi edinin](https://example.com/help/deployment-status)",
      "Link a [commit](https://example.com/help/commit), [pull request](https://example.com/help/pull-request) or [branch](https://example.com/help/branch) to see the status of your development. You can also [create a branch](https://example.com/help/new-branch) to get started.": "Geliştirmenizin durumunu görmek için bir [işleme](https://example.com/help/commit), [çekme isteği](https://example.com/help/pull-request) veya [dal](https://example.com/help/branch) bağlayın. Başlamak için ayrıca [bir dal oluşturabilirsiniz](https://example.com/help/new-branch).",
      "Work item": "İş öğesi",
      "Pull request": "Çekme isteği"
    },
    "fa": {
      "Bug": "باگ",
      "ID": "شناسه",
      "Work Item Type": "نوع مورد کاری",
      "Task": "وظیفه",
      "User Story": "داستان کاربر",
      "Title": "عنوان",
      "Assigned To": "واگذارشده به",
      "Comments": "نظر",
      "Comment": "نظر",
      "Tags": "تگ‌ها",
      "State": "وضعیت",
      "New": "جدید",
      "Active": "فعال",
      "Resolved": "حل‌شده",
      "Closed": "بسته‌شده",
      "Reason": "دلیل",
      "Approved": "تأییدشده",
      "Investigation Complete": "بررسی کامل شد",
      "Fixed": "رفع شد",
      "Verified": "صحت‌سنجی شد",
      "Area": "ناحیه",
      "Iteration": "تکرار",
      "Repro Steps": "مراحل بازتولید",
      "System Info": "اطلاعات سیستم",
      "Category": "دسته",
      "Business": "کسب‌وکار",
      "Architectural": "معماری",
      "Resolved Reason": "دلیل حل شدن",
      "Duplicate": "تکراری",
      "As Designed": "طبق طراحی",
      "Cannot Reproduce": "قابل بازتولید نیست",
      "Story Points": "امتیاز داستان",
      "Priority": "اولویت",
      "Severity": "شدت",
      "1 - Critical": "1 - بحرانی",
      "2 - High": "2 - بالا",
      "3 - Medium": "3 - متوسط",
      "4 - Low": "4 - پایین",
      "Activity": "فعالیت",
      "Deployment": "استقرار",
      "Design": "طراحی",
      "Development": "توسعه",
      "Documentation": "مستندسازی",
      "Requirements": "نیازمندی‌ها",
      "Testing": "آزمون",
      "Original Estimate": "برآورد اولیه",
      "Remaining": "باقی‌مانده",
      "Completed": "انجام‌شده",
      "Related Work": "کارهای مرتبط",
      "Found in Build": "یافت‌شده در ساخت",
      "Integrated in Build": "ادغام‌شده در ساخت",
      "Changed By": "تغییر توسط",
      "Changed Date": "تاریخ تغییر",
      "Following": "در حال دنبال کردن",
      "Attachments": "پیوست‌ها",
      "No one selected": "کسی انتخاب نشده است",
      "Add Tag": "افزودن تگ",
      "Save and Close": "ذخیره و بستن",
      "Save": "ذخیره",
      "Follow": "دنبال کردن",
      "Notification settings": "تنظیمات اعلان‌ها",
      "All changes": "همهٔ تغییرات",
      "State changes": "تغییرات وضعیت",
      "Refresh": "تازه‌سازی",
      "Revert changes": "بازگرداندن تغییرات",
      "Set by the workflow when the State changes": "هنگام تغییر وضعیت، گردش کار آن را تعیین می‌کند",
      "Set when the bug is resolved": "هنگام حل شدن باگ تعیین می‌شود",
      "Copy link": "کپی پیوند",
      "New linked work item": "مورد کاری پیوندشدهٔ جدید",
      "Change type…": "تغییر نوع…",
      "Move to team project…": "انتقال به پروژهٔ تیمی…",
      "Create copy of work item…": "ایجاد کپی از مورد کاری…",
      "Email work item": "ارسال مورد کاری با ایمیل",
      "Delete": "حذف",
      "Templates": "الگوها",
      "Capture…": "ذخیره به‌عنوان الگو…",
      "New branch…": "شاخهٔ جدید…",
      "Customize": "سفارشی‌سازی",
      "Details": "جزئیات",
      "History": "تاریخچه",
      "Links": "پیوندها",
      "Discussion": "گفتگو",
      "Planning": "برنامه‌ریزی",
      "Effort (Hours)": "میزان کار (ساعت)",
      "Click to add System Info.": "برای افزودن اطلاعات سیستم کلیک کنید.",
      "Add an existing work item as a parent": "افزودن یک مورد کاری موجود به‌عنوان والد",
      "To track releases associated with this work item, go to [Releases](https://example.com/releases) and turn on deployment status reporting for Boards in your pipeline's Options menu. [Learn more about deployment status reporting](https://example.com/help/deployment-status)": "برای پیگیری انتشارهای مرتبط با این مورد کاری، به [انتشارها](https://example.com/releases) بروید و در منوی گزینه‌های خط لولهٔ خود، گزارش وضعیت استقرار را برای تابلوها فعال کنید. [دربارهٔ گزارش وضعیت استقرار بیشتر بدانید](https://example.com/help/deployment-status)",
      "Link a [commit](https://example.com/help/commit), [pull request](https://example.com/help/pull-request) or [branch](https://example.com/help/branch) to see the status of your development. You can also [create a branch](https://example.com/help/new-branch) to get started.": "یک [کامیت](https://example.com/help/commit)، [درخواست ادغام](https://example.com/help/pull-request) یا [شاخه](https://example.com/help/branch) را پیوند دهید تا وضعیت توسعهٔ خود را ببینید. همچنین می‌توانید برای شروع، [یک شاخه ایجاد کنید](https://example.com/help/new-branch).",
      "Work item": "مورد کاری",
      "Pull request": "درخواست ادغام"
    },
    "ur": {
      "Bug": "بگ",
      "ID": "آئی ڈی",
      "Work Item Type": "ورک آئٹم کی قسم",
      "Task": "ٹاسک",
      "User Story": "یوزر اسٹوری",
      "Title": "عنوان",
      "Assigned To": "تفویض کردہ",
      "Comments": "تبصرے",
      "Comment": "تبصرہ",
      "Tags": "ٹیگز",
      "State": "حالت",
      "New": "نیا",
      "Active": "فعال",
      "Resolved": "حل شدہ",
      "Closed": "بند",
      "Reason": "وجہ",
      "Approved": "منظور شدہ",
      "Investigation Complete": "تحقیق مکمل",
      "Fixed": "درست کر دیا گیا",
      "Verified": "تصدیق شدہ",
      "Area": "شعبہ",
      "Iteration": "تکرار",
      "Repro Steps": "مسئلہ دہرانے کے مراحل",
      "System Info": "سسٹم کی معلومات",
      "Category": "زمرہ",
      "Business": "کاروباری",
      "Architectural": "آرکیٹیکچرل",
      "Resolved Reason": "حل کی وجہ",
      "Duplicate": "نقل",
      "As Designed": "ڈیزائن کے مطابق",
      "Cannot Reproduce": "دہرایا نہیں جا سکتا",
      "Story Points": "اسٹوری پوائنٹس",
      "Priority": "ترجیح",
      "Severity": "شدت",
      "1 - Critical": "1 - نازک",
      "2 - High": "2 - زیادہ",
      "3 - Medium": "3 - درمیانی",
      "4 - Low": "4 - کم",
      "Activity": "سرگرمی",
      "Deployment": "تعیناتی",
      "Design": "ڈیزائن",
      "Development": "ڈیولپمنٹ",
      "Documentation": "دستاویزات",
      "Requirements": "ضروریات",
      "Testing": "ٹیسٹنگ",
      "Original Estimate": "ابتدائی تخمینہ",
      "Remaining": "باقی",
      "Completed": "مکمل شدہ",
      "Related Work": "متعلقہ کام",
      "Found in Build": "بلڈ میں پایا گیا",
      "Integrated in Build": "بلڈ میں شامل کیا گیا",
      "Changed By": "تبدیل کنندہ",
      "Changed Date": "تبدیلی کی تاریخ",
      "Following": "فالو کر رہے ہیں",
      "Attachments": "منسلکات",
      "No one selected": "کوئی منتخب نہیں",
      "Add Tag": "ٹیگ شامل کریں",
      "Save and Close": "محفوظ کریں اور بند کریں",
      "Save": "محفوظ کریں",
      "Follow": "فالو کریں",
      "Notification settings": "اطلاعات کی ترتیبات",
      "All changes": "تمام تبدیلیاں",
      "State changes": "حالت کی تبدیلیاں",
      "Refresh": "تازہ کریں",
      "Revert changes": "تبدیلیاں ترک کریں",
      "Set by the workflow when the State changes": "حالت بدلنے پر ورک فلو اس کا تعین کرتا ہے",
      "Set when the bug is resolved": "بگ حل ہونے پر اس کا تعین ہوتا ہے",
      "Copy link": "لنک کاپی کریں",
      "New linked work item": "نیا لنک شدہ ورک آئٹم",
      "Change type…": "قسم تبدیل کریں…",
      "Move to team project…": "ٹیم پروجیکٹ میں منتقل کریں…",
      "Create copy of work item…": "ورک آئٹم کی کاپی بنائیں…",
      "Email work item": "ورک آئٹم ای میل کریں",
      "Delete": "حذف کریں",
      "Templates": "سانچے",
      "Capture…": "سانچہ بنائیں…",
      "New branch…": "نئی برانچ…",
      "Customize": "حسب ضرورت بنائیں",
      "Details": "تفصیلات",
      "History": "تاریخچہ",
      "Links": "لنکس",
      "Discussion": "بحث",
      "Planning": "منصوبہ بندی",
      "Effort (Hours)": "کوشش (گھنٹے)",
      "Click to add System Info.": "سسٹم کی معلومات شامل کرنے کے لیے کلک کریں۔",
      "Add an existing work item as a parent": "کسی موجودہ ورک آئٹم کو پیرنٹ کے طور پر شامل کریں",
      "To track releases associated with this work item, go to [Releases](https://example.com/releases) and turn on deployment status reporting for Boards in your pipeline's Options menu. [Learn more about deployment status reporting](https://example.com/help/deployment-status)": "اس ورک آئٹم سے متعلق ریلیزز پر نظر رکھنے کے لیے [ریلیزز](https://example.com/releases) پر جائیں اور اپنی پائپ لائن کے اختیارات کے مینو میں بورڈز کے لیے تعیناتی کی حالت کی رپورٹنگ آن کریں۔ [تعیناتی کی حالت کی رپورٹنگ کے بارے میں مزید جانیں](https://example.com/help/deployment-status)",
      "Link a [commit](https://example.com/help/commit), [pull request](https://example.com/help/pull-request) or [branch](https://example.com/help/branch) to see the status of your development. You can also [create a branch](https://example.com/help/new-branch) to get started.": "اپنی ڈیولپمنٹ کی صورتحال دیکھنے کے لیے کوئی [کمٹ](https://example.com/help/commit)، [پل ریکویسٹ](https://example.com/help/pull-request) یا [برانچ](https://example.com/help/branch) لنک کریں۔ شروع کرنے کے لیے آپ [برانچ بھی بنا سکتے ہیں](https://example.com/help/new-branch)۔",
      "Work item": "ورک آئٹم",
      "Pull request": "پل ریکویسٹ"
    },
    "es": {
      "Bug": "Error",
      "ID": "Id.",
      "Work Item Type": "Tipo de elemento de trabajo",
      "Task": "Tarea",
      "User Story": "Historia de usuario",
      "Title": "Título",
      "Assigned To": "Asignado a",
      "Comments": "Comentarios",
      "Comment": "Comentario",
      "Tags": "Etiquetas",
      "State": "Estado",
      "New": "Nuevo",
      "Active": "Activo",
      "Resolved": "Resuelto",
      "Closed": "Cerrado",
      "Reason": "Motivo",
      "Approved": "Aprobado",
      "Investigation Complete": "Investigación completada",
      "Fixed": "Corregido",
      "Verified": "Verificado",
      "Area": "Área",
      "Iteration": "Iteración",
      "Repro Steps": "Pasos de reproducción",
      "System Info": "Información del sistema",
      "Category": "Categoría",
      "Business": "Negocio",
      "Architectural": "Arquitectura",
      "Resolved Reason": "Motivo de resolución",
      "Duplicate": "Duplicado",
      "As Designed": "Según el diseño",
      "Cannot Reproduce": "No se puede reproducir",
      "Story Points": "Puntos de historia",
      "Priority": "Prioridad",
      "Severity": "Gravedad",
      "1 - Critical": "1 - Crítica",
      "2 - High": "2 - Alta",
      "3 - Medium": "3 - Media",
      "4 - Low": "4 - Baja",
      "Activity": "Actividad",
      "Deployment": "Implementación",
      "Design": "Diseño",
      "Development": "Desarrollo",
      "Documentation": "Documentación",
      "Requirements": "Requisitos",
      "Testing": "Pruebas",
      "Original Estimate": "Estimación original",
      "Remaining": "Restante",
      "Completed": "Completado",
      "Related Work": "Trabajo relacionado",
      "Found in Build": "Encontrado en la compilación",
      "Integrated in Build": "Integrado en la compilación",
      "Changed By": "Modificado por",
      "Changed Date": "Fecha de modificación",
      "Following": "Siguiendo",
      "Attachments": "Adjuntos",
      "No one selected": "Nadie seleccionado",
      "Add Tag": "Añadir etiqueta",
      "Save and Close": "Guardar y cerrar",
      "Save": "Guardar",
      "Follow": "Seguir",
      "Notification settings": "Configuración de notificaciones",
      "All changes": "Todos los cambios",
      "State changes": "Cambios de estado",
      "Refresh": "Actualizar",
      "Revert changes": "Revertir los cambios",
      "Set by the workflow when the State changes": "Lo establece el flujo de trabajo cuando cambia el estado",
      "Set when the bug is resolved": "Se establece cuando se resuelve el error",
      "Copy link": "Copiar enlace",
      "New linked work item": "Nuevo elemento de trabajo vinculado",
      "Change type…": "Cambiar tipo…",
      "Move to team project…": "Mover a un proyecto de equipo…",
      "Create copy of work item…": "Crear una copia del elemento de trabajo…",
      "Email work item": "Enviar el elemento de trabajo por correo electrónico",
      "Delete": "Eliminar",
      "Templates": "Plantillas",
      "Capture…": "Capturar…",
      "New branch…": "Nueva rama…",
      "Customize": "Personalizar",
      "Details": "Detalles",
      "History": "Historial",
      "Links": "Enlaces",
      "Discussion": "Discusión",
      "Planning": "Planificación",
      "Effort (Hours)": "Esfuerzo (horas)",
      "Click to add System Info.": "Haga clic para añadir información del sistema.",
      "Add an existing work item as a parent": "Añadir un elemento de trabajo existente como primario",
      "To track releases associated with this work item, go to [Releases](https://example.com/releases) and turn on deployment status reporting for Boards in your pipeline's Options menu. [Learn more about deployment status reporting](https://example.com/help/deployment-status)": "Para hacer un seguimiento de las versiones asociadas a este elemento de trabajo, vaya a [Versiones](https://example.com/releases) y active los informes de estado de implementación para los paneles en el menú Opciones de su canalización. [Más información sobre los informes de estado de implementación](https://example.com/help/deployment-status)",
      "Link a [commit](https://example.com/help/commit), [pull request](https://example.com/help/pull-request) or [branch](https://example.com/help/branch) to see the status of your development. You can also [create a branch](https://example.com/help/new-branch) to get started.": "Vincule una [confirmación](https://example.com/help/commit), una [solicitud de incorporación de cambios](https://example.com/help/pull-request) o una [rama](https://example.com/help/branch) para ver el estado de su desarrollo. También puede [crear una rama](https://example.com/help/new-branch) para empezar.",
      "Work item": "un elemento de trabajo",
      "Pull request": "una solicitud de incorporación de cambios"
    }
  }
}
